<template>
    <div class="flex flex-wrap" :class="classes">
        <template v-if="$widgetUI=='OLD-UI'">
            <div class="mr-1 mb-1"
                 v-if="values.length > 1 && viewAll">
                <label :class="[modelAll ? 'bg-primary text-white' : 'bg-gray-200']"
                       class="flex items-center rounded-full py-2 px-4 cursor-pointer leading-none capitalize">
                    <input type="checkbox"
                           v-model="modelAll"
                           @change="checkAll"
                           class="hidden"/>
                    <icon-check :class="{modelAll: 'mr-1'}"
                                :h="modelAll ? 14 : 0"
                                :w="modelAll ? 17 : 0"/>
                    All
                </label>
            </div>
            <div class="mr-1 mb-1"
                 v-for="value in values"
                 :key="value.key">
                <label :class="[model.includes(value.value) ? 'bg-primary text-white' : 'bg-gray-200']"
                       class="flex items-center rounded-full py-2 px-4 cursor-pointer leading-none capitalize">
                    <input
                        type="checkbox"
                        :value="value.value"
                        v-model="model"
                        class="hidden"
                    />
                    <icon-check :class="{'mr-1': model.includes(value.value)}"
                                :h="model.includes(value.value) ? 14 : 0"
                                :w="model.includes(value.value) ? 17 : 0"/>
                    {{ value.title.toLowerCase() }}
                </label>
            </div>
        </template>
        <template v-else>
            <div class="mr-1 mb-1"
                 v-if="values.length > 1 && viewAll">
                <label :class="[modelAll ? 'bg-primary text-white' : 'bg-gray-100 text-primary']"
                       class="flex items-center rounded-full py-2 px-4 cursor-pointer leading-none capitalize">
                    <input type="checkbox"
                           v-model="modelAll"
                           @change="checkAll"
                           class="hidden"/>
                    <icon-check :class="{modelAll: 'mr-1'}"
                                :h="modelAll ? 14 : 0"
                                :w="modelAll ? 17 : 0"/>
                    All
                </label>
            </div>
            <div class="mr-1 mb-1"
                 v-for="value in values"
                 :key="value.key">
                <label :class="[model.includes(value.value) ? 'bg-primary text-white' : 'bg-gray-100 text-primary']"
                       class="flex items-center rounded-full py-2 px-4 cursor-pointer leading-none capitalize">
                    <input
                        type="checkbox"
                        :value="value.value"
                        v-model="model"
                        class="hidden"
                    />
                    <icon-check :class="{'mr-1': model.includes(value.value)}"
                                :h="model.includes(value.value) ? 14 : 0"
                                :w="model.includes(value.value) ? 17 : 0"/>
                    {{ value.title.toLowerCase() }}
                </label>
            </div>
        </template>
    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";

export default {
    name: "checkboxes",
    props: {
        item: {
            type: Object,
            require: true,
            default: () => {
                return {};
            }
        },
        viewAll: {
            type: Boolean,
            default: true
        },
        classes: {
            type: String,
            default: ""
        }
    },
    computed: {
        values () {
            return this.item.values;
        },
        model: {
            set (value) {
                if (value.length) {
                    this.modelAll = false;
                    let title = this.values.filter(item => value.includes(item.value)).map(item => item.title.charAt(0).toUpperCase() + item.title.toLowerCase().slice(1)).join(", ");
                    this.$store.commit("widgetData/addSelect", {
                        sensitive: this.item.attentionText !== "",
                        code: this.item.code,
                        group: this.item.group,
                        title: `${this.item.title}: ${title}`,
                        query: value
                    });
                } else {
                    this.checkAll();
                }
            },
            get () {
                let modelStore = this.$store.getters["widgetData/getSelectByCode"](this.item.code);
                if (modelStore) {
                    this.modelAll = false;
                    this.$emit("open");
                    return modelStore.query;
                }
                return [];
            }
        }
    },
    methods: {
        checkAll () {
            this.modelAll = true;
            this.$store.commit("widgetData/removeSelect", this.item.code);
        }
    },
    data () {
        return {
            modelAll: true
        };
    },
    mounted () {
        EventBus.$on("remove-select", code => {
            if (code === this.item.code) {
                this.modelAll = true;
                this.$emit("close");
            }
        });

        EventBus.$on("clear-all", () => {
            this.modelAll = true;
            this.$emit("close");
        });
    }
};
</script>
